import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getMailboxJunkEmailConfiguration from '../services/getMailboxJunkEmailConfiguration';

export default action('initMailboxJunkEmailConfiguration')(
    async function initMailboxJunkEmailConfiguration() {
        // Always reload the junk email configuration because the user may change
        // the configuration at any time by blocking senders of individual emails
        store.mailboxJunkEmailConfiguration = await getMailboxJunkEmailConfiguration();
        store.mailboxJunkEmailConfiguration.BlockedSendersAndDomains = store.mailboxJunkEmailConfiguration.BlockedSendersAndDomains.sort();
        store.mailboxJunkEmailConfiguration.TrustedSendersAndDomains = store.mailboxJunkEmailConfiguration.TrustedSendersAndDomains.sort();
        store.mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains = store.mailboxJunkEmailConfiguration.TrustedRecipientsAndDomains.sort();
    }
);
